import {NgModule} from '@angular/core';
import {QuoteStatusStylePipe} from './quote-status-style-pipe';

@NgModule({
    imports: [QuoteStatusStylePipe],
    exports: [
        QuoteStatusStylePipe
    ]
})
export class AppPipesModule {
 }
